module.exports = __webpack_public_path__ + "static/img/logo-pdf.34c5b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-pdf.png
// module id = Z0Wk
// module chunks = 18